<div class="grid grid-cols-2 gap-2">
  <div class="flex flex-col" *ngFor="let key of marginKeys">
    <label [tailLabel]="i">{{getMarginLabel(key)}}</label>
    <input tailInput #i="input" type="number" [(ngModel)]="value[key]">
  </div>
</div>
